export default __webpack_public_path__ + "static/media/R5C_8143.1774837e.jpg";